export {
  snapshot,
  isDirty,
  shouldConfirmLeave,
  isLeavingNavigation,
  isGuardableAnchorClick,
  ROUTE_PROGRESS_CANCEL_EVENT,
  DEFAULT_UNSAVED_MESSAGE,
  type DirtySnapshot,
  type GuardDecisionInput,
  type ClickLike,
  type AnchorLike,
} from './unsaved-changes-core';

export {
  UnsavedChangesProvider,
  useUnsavedChangesGuard,
  type UseUnsavedChangesGuardOptions,
  type UnsavedChangesGuard,
} from './use-unsaved-changes-guard';
